export default "/assets/images/construction.png?6b400e47dccd83686d31a6681c943a28";